"use client";

import type { IconProps } from "react-toastify/unstyled";
import Link from "src/components/common/Link/Link";
import StatusIcon from "src/components/common/StatusIcon/StatusIcon";
import { useExtracted } from "#i18n";

export const ToastHelpLink = () => {
  const translateMessage = useExtracted();
  return (
    <Link variant={"hyperlink"} href={"/help"}>
      {translateMessage("Help")}
    </Link>
  );
};

export const ToastIcon = (props: Pick<IconProps, "type">) => {
  const { type } = props;
  if (type === "success") {
    return <StatusIcon color={"success"} />;
  }
  if (type === "error") {
    return <StatusIcon color={"danger"} />;
  }
  if (type === "warning") {
    return <StatusIcon color={"warning"} />;
  }
  return <StatusIcon color={"info"} />;
};
